export default __webpack_public_path__ + "locales/it/Files.json?hash=3ba13dcb8b26263f8184b282d99e829b";